export type ScoreFamily = 'profit' | 'win_rate';

export const SCORE_FAMILY_META = {
  profit: {
    label: 'Profitability',
    question: 'Would tailing every settled pick be profitable?',
    breakEvenLabel: '50 = break-even ROI',
    colorScheme: 'green',
    borderToken: 'accent.success',
    gradientLight: 'linear(to-br, green.50, emerald.100)',
    gradientDark: 'linear(to-br, green.900, emerald.800)',
    valueColorLight: 'green.700',
    valueColorDark: 'green.200',
    boxBgLight: 'green.50',
    boxBgDark: 'whiteAlpha.100',
  },
  win_rate: {
    label: 'Win-rate skill',
    question: 'How reliably do they pick winners?',
    breakEvenLabel: '50 = average · not break-even',
    colorScheme: 'cyan',
    borderToken: 'secondary.500',
    gradientLight: 'linear(to-br, secondary.50, cyan.100)',
    gradientDark: 'linear(to-br, secondary.900, cyan.800)',
    valueColorLight: 'secondary.700',
    valueColorDark: 'secondary.200',
    boxBgLight: 'secondary.50',
    boxBgDark: 'whiteAlpha.100',
  },
} as const;

export function scoreFamilyMeta(family: ScoreFamily) {
  return SCORE_FAMILY_META[family];
}
